package playground.gradient.ui

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import playground.gradient.data.Gradient

@Composable
internal fun ColumnScope.GradientTypePicker(
    modifier: Modifier = Modifier,
    currentGradientType: Gradient,
    setGradientType: (Gradient) -> Unit,
) {
    Text("Gradient Type")

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.SpaceAround
    ) {

        GradientTypeButton(
            gradient = Gradient.Linear,
            isSelected = currentGradientType is Gradient.Linear,
            setGradientType = setGradientType,
        )

        GradientTypeButton(
            gradient = Gradient.Radial,
            isSelected = currentGradientType is Gradient.Radial,
            setGradientType = setGradientType,
        )

        GradientTypeButton(
            gradient = Gradient.Sweep,
            isSelected = currentGradientType is Gradient.Sweep,
            setGradientType = setGradientType,
        )
//        Button(onClick = {
//            setGradientType(Gradient.Linear)
//        }) {
//            Text("Linear")
//        }
//
//        Button(onClick = {
//            setGradientType(Gradient.Radial)
//        }) {
//            Text("Radial")
//        }
//
//        Button(onClick = {
//            setGradientType(Gradient.Sweep)
//        }) {
//            Text("Sweep")
//        }
    }
}

@Composable
private fun GradientTypeButton(
    modifier: Modifier = Modifier,
    gradient: Gradient,
    isSelected: Boolean,
    setGradientType: (Gradient) -> Unit,
) {

    Box(
        modifier = modifier
            .padding(8.dp)
            .clip(CircleShape)
            .clickable {
                setGradientType(gradient)
            }
            .border(
                width = if (isSelected) 2.dp else Dp.Hairline,
                color = Color.White.copy(alpha = if (isSelected) .8f else .4f),
                shape = CircleShape,
            )
            .padding(horizontal = 32.dp, vertical = 8.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(gradient.type)
    }

}